import { routes, type RouteNamedMap } from 'vue-router/auto-routes'
import { setupLayouts } from 'virtual:generated-layouts'
import { createRouter, createWebHistory, type _RouterClassic } from 'vue-router'

export const router: _RouterClassic = createRouter({
  routes: setupLayouts(routes),
  history: createWebHistory(import.meta.env.BASE_URL),
})

declare module 'vue-router' {
  interface TypesConfig {
    Router: typeof router
    RouteNamedMap: RouteNamedMap
  }
}
